import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserStorage } from '@scisys-uim/uim-common';
import { TextSectionService } from 'assets-service';
import { BasePersistentTextSectionEntityComponent } from './base-persistent-text-section.component';


@Component({
  selector: 'persistent-rich-text-section-entity',
  templateUrl: './persistent-rich-text-section.component.html',
  styleUrls: ['./persistent-rich-text-section.component.scss']
})
export class PersistentRichTextSectionEntityComponent extends BasePersistentTextSectionEntityComponent {
  constructor(textSectionService: TextSectionService,
    userStorage: UserStorage,
    snackbar: MatSnackBar) {
    super(textSectionService, userStorage, snackbar);
  }
}
